import React, { useRef , useState} from "react";
import { Carousel } from 'primereact/carousel';
import '../css/Video.css';
const Video = () => {
  const carouselRef = useRef(null);
    const videos = [
    { id: 1, src: "/videos/videoColaDeGallo.mp4", title: "Cola de Gallo" },
    { id: 2, src: "/videos/videoIngredientesSalsa.mp4", title: "Ingredientes" }
  ];

  // Estado para controlar el índice actual
  const [activeIndex, setActiveIndex] = useState(0);

  // Avanzar automáticamente cuando termina un video
  const handleVideoEnd = () => {
    setActiveIndex((prev) => {
      const next = prev + 1;
      return next < videos.length ? next : 0; // reinicia al primero
    });
  };
  
  const videoTemplate = (video) => {
    return (
      <div className="video-item">
        <video
          key={video.id}
          controls
          onEnded={handleVideoEnd}
          className="carousel-video"
        >
          <source src={video.src} type="video/mp4" />
          Tu navegador no soporta el video.
        </video>
        <h3 className="video-title">{video.title}</h3>
      </div>
    );
  };

  return (
    <section className="video-container">
       <h2>Galería de Videos</h2>   
        
      <div className="video-wrapper">            
       <Carousel
        ref={carouselRef}
        value={videos}
        itemTemplate={videoTemplate}
        numVisible={1}
        numScroll={1}
        circular={false}       // no regresa al inicio automáticamente
        autoplayInterval={0}   // sin autoplay automático
        showIndicators={false} // opcional, puedes activarlo si deseas puntos de navegación
        page={activeIndex}              // posición actual
        onPageChange={(e) => setActiveIndex(e.page)} // actualiza al cambiar manualmente        
      />
      </div>
    </section>
  );
};

export default Video;